
// 有效码映射表
const vaildCodeMap = {
    '-1': '未知',
    '2': '无效',
    '3': '无效',
    '4': '无效',
    '5': '无效',
    '6': '无效',
    '7': '无效',
    '8': '无效',
    '9': '无效',
    '11': '无效',
    '13': '违规',
    '14': '无效',
    '15': '待付款',
    '16': '已付款',
    '17': '已完成',
    '19': '无效',
    '20': '无效',
    '21': '无效',
    '22': '无效',
    '23': '无效',
    '24': '已付定金',
    '25': '违规',
    '26': '违规',
    '27': '违规',
    '28': '违规',
    '29': '无效',
    '30': '无效',
    '31': '无效',
    '33': '超市卡',
    '34': '无效'
};
export {
  vaildCodeMap
}
